import { Button, Stack, TextField, Typography, Box, Divider, Alert } from "@mui/material";
import { useEffect, useState } from "react";
import { axiosi } from "../../../config/axios";
import { toast } from "react-toastify";

export const PaymentSettings = () => {
  const [bankDetails, setBankDetails] = useState({
    bankName: "HBL",
    accountTitle: "NEXOCART",
    accountNumber: "04897903603003"
  });
  const [easyPaisaDetails, setEasyPaisaDetails] = useState({
    holderName: "Sardar Laeiq Ahmed",
    phoneNumber: "03448252109"
  });
  const [contactNumbers, setContactNumbers] = useState({
    whatsapp: "03448252109",
    support: "03057410110"
  });
  const [email, setEmail] = useState("sardarlaeiq786@gmail.com");
  const [onlinePaymentDiscount, setOnlinePaymentDiscount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axiosi.get("/settings/payment");
        if (res.data) {
          if (res.data.bankDetails) setBankDetails(res.data.bankDetails);
          if (res.data.easyPaisaDetails) setEasyPaisaDetails(res.data.easyPaisaDetails);
          if (res.data.contactNumbers) setContactNumbers(res.data.contactNumbers);
          if (res.data.email) setEmail(res.data.email);
          setOnlinePaymentDiscount(res.data.onlinePaymentDiscount || 0);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await axiosi.post("/settings/payment", {
        bankDetails,
        easyPaisaDetails,
        contactNumbers,
        email,
        onlinePaymentDiscount: Number(onlinePaymentDiscount) || 0,
      });
      toast.success("Payment settings saved");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Stack maxWidth={700} margin="0 auto" mt={4} p={3} spacing={3} component="form" onSubmit={handleSave}>
      <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
        💳 Payment Methods & Contact Information
      </Typography>

      <Alert severity="info">
        Update payment methods that will be shown to customers during checkout.
      </Alert>

      {/* Bank Details Section */}
      <Box>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>🏦 Bank Transfer Details</Typography>
        <Stack spacing={2}>
          <TextField
            label="Bank Name"
            value={bankDetails.bankName}
            onChange={(e) => setBankDetails({ ...bankDetails, bankName: e.target.value })}
            fullWidth
          />
          <TextField
            label="Account Title"
            value={bankDetails.accountTitle}
            onChange={(e) => setBankDetails({ ...bankDetails, accountTitle: e.target.value })}
            fullWidth
          />
          <TextField
            label="Account Number"
            value={bankDetails.accountNumber}
            onChange={(e) => setBankDetails({ ...bankDetails, accountNumber: e.target.value })}
            fullWidth
          />
        </Stack>
      </Box>

      <Divider />

      {/* Easy Paisa Details Section */}
      <Box>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>💳 Easy Paisa Details</Typography>
        <Stack spacing={2}>
          <TextField
            label="Account Holder Name"
            value={easyPaisaDetails.holderName}
            onChange={(e) => setEasyPaisaDetails({ ...easyPaisaDetails, holderName: e.target.value })}
            fullWidth
          />
          <TextField
            label="Phone Number"
            value={easyPaisaDetails.phoneNumber}
            onChange={(e) => setEasyPaisaDetails({ ...easyPaisaDetails, phoneNumber: e.target.value })}
            fullWidth
          />
        </Stack>
      </Box>

      <Divider />

      {/* Contact Information Section */}
      <Box>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>📱 Contact Information</Typography>
        <Stack spacing={2}>
          <TextField
            label="WhatsApp Support Number"
            value={contactNumbers.whatsapp}
            onChange={(e) => setContactNumbers({ ...contactNumbers, whatsapp: e.target.value })}
            fullWidth
          />
          <TextField
            label="Support Phone Number"
            value={contactNumbers.support}
            onChange={(e) => setContactNumbers({ ...contactNumbers, support: e.target.value })}
            fullWidth
          />
          <TextField
            label="Email Address"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
          />
        </Stack>
      </Box>

      <Divider />

      {/* Discount Section */}
      <Box>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>🏷️ Discount</Typography>
        <TextField
          label="Online Payment Discount (%)"
          type="number"
          value={onlinePaymentDiscount}
          onChange={(e) => setOnlinePaymentDiscount(e.target.value)}
          inputProps={{ min: 0, max: 100 }}
          fullWidth
          helperText="Discount offered for online payments"
        />
      </Box>

      <Button variant="contained" type="submit" disabled={loading} size="large">
        {loading ? "Saving..." : "💾 Save All Settings"}
      </Button>
    </Stack>
  );
};
